export default __webpack_public_path__ + "static/media/toolkit-landing-hero-bg.d4cbd38c.svg";